module.exports = __webpack_public_path__ + "img/xj3.8fe2b964.png";